import { axios } from "../axios.instance";

export type CreatePaymentOrderRequest = { productId: string };

export type CreatePaymentOrderResponse = {
  id: string;
};

export const createPaymentOrder = async (body: CreatePaymentOrderRequest): Promise<CreatePaymentOrderResponse> => {
  const { data } = await axios.post(`/payments/orders`, body);

  return data;
};
